import React from "react";
import { Stack, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AvatarStack from "../../components/Avatar/AvatarStack";

/**
 * CollectionCategoryCard
 * 카테고리 요약 카드: 타이틀, 컬렉션 수, 참가자(아바타+이름)
 * @param {object} props
 * @param {string} props.label
 * @param {number} props.count
 * @param {Array} props.users - { id, profile: { id, username, name }, fallbackUrl }
 * @param {boolean} [props.isMobile]
 * @param {function} [props.onClick]
 */
function CollectionCategoryCard({ label, count, users = [], isMobile = false, onClick }) {
  const theme = useTheme();

  const visibleNames = users
    .slice(0, isMobile ? 3 : 5)
    .map((u) => u?.profile?.username || u?.profile?.name || "")
    .filter(Boolean);

  return (
    <Stack
      spacing={isMobile ? 2 : 0}
      sx={{
        width: "100%",
        py: isMobile ? 3 : 5,
        px: isMobile ? 2 : "32px",
        minHeight: isMobile ? 180 : 240,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        cursor: "pointer",
        transition: "background-color 0.2s ease-in-out, color 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          "& *": { color: theme.palette.background.paper + " !important" },
        },
      }}
      onClick={onClick}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant={isMobile ? "body1" : "h5"}
          sx={{
            fontFamily:
              '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
            fontWeight: 900,
            color: theme.palette.text.primary,
            lineHeight: 1.4,
            mb: isMobile ? 1 : 2,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant={isMobile ? "caption" : "body2"}
          sx={{ color: theme.palette.text.secondary, fontWeight: 700 }}
        >
          컬렉션 {count}개
        </Typography>
      </Box>

      <Stack spacing={1} sx={{ minWidth: 0 }}>
        <AvatarStack
          users={users}
          maxVisible={isMobile ? 4 : 6}
          size={isMobile ? 28 : 36}
          overlap={isMobile ? 8 : 10}
        />
        {visibleNames.length > 0 && (() => {
          const totalUsers = Array.isArray(users) ? users.length : 0;
          const firstName = visibleNames[0] || "";
          const othersCount = Math.max(0, totalUsers - 1);
          const displayText = othersCount > 0 ? `${firstName} 외 ${othersCount}명` : firstName;
          return (
            <Typography
              variant={isMobile ? "caption" : "body2"}
              sx={{
                color: theme.palette.text.secondary,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={displayText}
            >
              {displayText}
            </Typography>
          );
        })()}
      </Stack>
    </Stack>
  );
}

export default CollectionCategoryCard;


